<template>
  <gj-select
      ref="virtualSelect"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="value"
      type="custom"
      popper-class="gj-custom-select--popper"
      :loading="loading"
      @focus="handleFocus">
    <el-option value="-1">
      <div @click.stop class="virtual-box">
        <el-input
            ref="searchInput"
            v-model="searchText"
            placeholder="搜索..."
            size="small"
            style="width:90%; margin-left:5%;margin-bottom:6px;"
        ></el-input>
        <vxe-list :data="checkOptions" :loading="loading" :scroll-y="{enabled: true}" :height="240" ref="vxeListRef">
          <template #default="{ items }">
            <el-option
                v-for="item in items"
                :key="item[valueKey]"
                :label="item[labelKey]"
                :value="item[valueKey]">
                <gj-text :width="'160px'" class="label-name-box">{{item[labelKey]}}</gj-text>
            </el-option>
          </template>
        </vxe-list>
      </div>
    </el-option>
  </gj-select>
</template>

<script>
  export default {
    name: 'gj-virtual-select',
    props: {
      value: {
        required: true,
      },
      list: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      labelKey: {
        type: String,
        default: 'text'
      },
      valueKey: {
        type: String,
        default: 'id'
      }
    },
    data() {
      return {
        searchText: '',
        checkOptions: []
      }
    },
    watch: {
      list: {
        handler(newVal, oldVal) {
          if (newVal) {
            const map = new Map();
            const newList = newVal.filter((item) => !map.has(item[this.valueKey]) && map.set(item[this.valueKey], 1))

            //数据index抬升
            let index = newList.findIndex(item => item[this.valueKey] == this.value)
            if(index > 0) {
              let item = newList.splice(index, 1)
              this.checkOptions = [...item, ...newVal]
            } else {
              this.checkOptions = newList
            }

          }
        },
        immediate: true
      },
      searchText: function (val) {
        if (this.list.length > 0) {
          this.checkOptions = val === '' ? this.list : this.list.filter(v => v[this.labelKey].includes(val))
        }
      }
    },
    methods: {
      // 方案2 移到上次滚动位置
      handleFocus() {
        this.$refs.vxeListRef.refreshScroll()
        // 滚动1px解决虚拟滚动白屏问题
        setTimeout(() => {
          this.$refs.vxeListRef.scrollTo(0, 1);
        }, 100);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .virtual-box {
    padding: 6px 0;

    /deep/ .el-select-dropdown__item {
      padding: 0 20px;
    }

    /deep/ .el-select-dropdown__item:hover {
      background-color: #f5f7fa;
    }

  }
</style>
